import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const FuncionarioRedirect: React.FC = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Redireciona para a listagem de funcionários
    navigate('/funcionarios');
  }, [navigate]);

  return null;
};

export default FuncionarioRedirect;
